import { Card, Title, Text, LoadingOverlay, Box, Flex } from '@mantine/core';
import { useFetch } from '@mantine/hooks';
import { ICourse } from '../../../interfaces/ICourse';
import { CourseCard } from './CourseCard';

export function AvailableCourses() {
  const { data, loading } = useFetch<{ data: ICourse[] }>(
    `${import.meta.env.VITE_API_URL}/services/userCourses`,
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  const availableCourses = data?.data?.filter(course => !course.unlocked) || [];

  return (
    <Card shadow='sm' withBorder p='sm' radius='sm'>
      <Title order={4} mb='sm'>
        Corsi Disponibili
      </Title>
      <LoadingOverlay visible={loading} />
      <Box style={{ overflowX: 'scroll' }} pb={20}>
        {availableCourses.length > 0 ? (
          <Flex gap='sm' wrap='nowrap' p={5}>
            {availableCourses.map(course => (
              <CourseCard key={course.id} course={course} />
            ))}
          </Flex>
        ) : (
          <Text c='dimmed' ta='center'>
            Hai acquistato tutti i corsi
          </Text>
        )}
      </Box>
    </Card>
  );
}
